module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pullList.length > 0) ? _c('div', {
    staticClass: "pulls-wrapper"
  }, [_c('h2', [_c('span', {
    staticClass: "header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Pull Requests: " + _vm._s(_vm.pullCount))])]), _vm._v(" "), _vm._l((_vm.pullList), function(p) {
    return _c('div', {
      key: p.pullRequestId,
      staticClass: "pull",
      class: _vm.getClass(p)
    }, [_c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(p.description))]), _vm._v(" "), _c('div', {
      staticClass: "metrics"
    }, [(p.conflicts) ? _c('span', {
      staticClass: "conflict"
    }, [_vm._v("Conflicts")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fas fa-code-branch fa-lg fa-fw"
    }), _vm._v("\n\t\t\t" + _vm._s(p.sourceBranch) + "\n\t\t\t"), _c('i', {
      staticClass: "fas fa-arrow-right fa-lg fa-fw"
    }), _vm._v("\n\t\t\t" + _vm._s(p.targetBranch) + "\n\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_vm._v(_vm._s(p.repository) + " - " + _vm._s(p.user) + " - " + _vm._s(p.relativeDateString))])])
  }), _vm._v(" "), (_vm.moreCount > 0) ? _c('div', {
    staticClass: "show-more"
  }, [_c('i', {
    staticClass: "fas fa-arrow-down fa-lg"
  }), _vm._v(" " + _vm._s(_vm.moreCount) + " more")]) : _vm._e()], 2) : _c('div', {
    staticClass: "pulls-wrapper empty"
  }, [_c('img', {
    attrs: {
      "src": "/images/pusheen.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("No Pull Requests")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ce6a0e16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/dev-pulls.vue
// module id = 579
// module chunks = 0